import gql from 'graphql-tag';

export const CREATE_PROPOSAL_MENU_OPTION = gql`
  mutation ($input: CreateProposalMenuOptionInput) {
    createProposalMenuOption(input: $input) {
      proposalMenuOptionId
    }
  }
`;
